import { render, staticRenderFns } from "./Piepagina.vue?vue&type=template&id=88e46646&scoped=true"
import script from "./Piepagina.vue?vue&type=script&lang=js"
export * from "./Piepagina.vue?vue&type=script&lang=js"
import style0 from "./Piepagina.vue?vue&type=style&index=0&id=88e46646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e46646",
  null
  
)

export default component.exports